import React from 'react';
import { Card, CardContent, Typography, TextField, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import type { PlanData } from '@app-types/visit';
import { EventAvailable } from '@mui/icons-material';

interface PlanCardProps {
  plan: PlanData;
  onChange: (plan: PlanData) => void;
  disabled?: boolean;
}

const PlanCard: React.FC<PlanCardProps> = React.memo(({ plan, onChange, disabled = false }) => {
  const updateField = <K extends keyof PlanData>(field: K, value: PlanData[K]) => {
    onChange({ ...plan, [field]: value });
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <EventAvailable sx={{ mr: 1, color: 'success.main' }} />
          <Typography variant="h6">Plan</Typography>
        </Box>
        
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Investigații recomandate"
              value={plan.investigations ?? ''}
              onChange={(e) => updateField('investigations', e.target.value)}
              disabled={disabled}
              placeholder="ex: Analize sânge complet, radiografie abdomen"
            />
          </Grid>
          
          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Plan de tratament"
              value={plan.treatments ?? ''}
              onChange={(e) => updateField('treatments', e.target.value)}
              disabled={disabled}
              placeholder="ex: Antibiotic 7 zile, antiinflamator 5 zile"
            />
          </Grid>
          
          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Recomandări îngrijire acasă"
              value={plan.homeCare ?? ''}
              onChange={(e) => updateField('homeCare', e.target.value)}
              disabled={disabled}
              placeholder="ex: Odihnă, alimentație dietetică, evitați efortul fizic"
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              type="date"
              label="Rechemare la"
              InputLabelProps={{ shrink: true }}
              value={plan.recallDate ?? ''}
              onChange={(e) => updateField('recallDate', e.target.value)}
              disabled={disabled}
              helperText="Va crea automat un reminder pentru proprietar"
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Motiv rechemare"
              value={plan.recallReason ?? ''}
              onChange={(e) => updateField('recallReason', e.target.value)}
              disabled={disabled}
              placeholder="ex: Control post-tratament, scoatere fire"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

PlanCard.displayName = 'PlanCard';

export default PlanCard;

